module.exports = __webpack_public_path__ + "img/banner2.bdf08708.png";